<template>
  <v-btn
    :to="to"
    style="font-size: 19px; font-weight: 300"
    class="p-r-1"
    exact
  >
    <span class="text-grey-darken-1 text-none font-weight-medium">
      <slot></slot>
    </span>
  </v-btn>
</template>

<script setup lang="ts">
  import { PropType } from 'vue';
  import { RouteLocationRaw } from 'vue-router';
  defineProps({
    to: { type: Object as PropType<RouteLocationRaw | string>, required: true },
  });
</script>

<style scoped>
  .v-btn.v-btn--active span {
    color: white !important;
    border-bottom: 1px solid white;
  }
.v-btn.v-btn--active {
    background-color:#020202;
    border-radius: 30px;
  }
.v-btn.v-btn--hover {
    background-color:transparent;
    transition: none;
  }
</style>
